export default "__VITE_ASSET__DFj2oQQl__"